import { colors } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'

const styles = makeStyles((theme) => ({
  containerMessages: {
    overflowY: 'auto',
    paddingRight: 14,
  },
  chip: {
    fontWeight: 500,
    maxWidth: 200,
    textTransform: 'uppercase',
  },
  pendingStatus: {
    backgroundColor: colors.lightBlue[100],
    color: colors.lightBlue[800],
  },
  finalizedStatus: {
    backgroundColor: colors.green[100],
    color: colors.green[800],
  },
  convertedIncidentStatus: {
    backgroundColor: colors.red[100],
    color: colors.red[800],
  },
  invalidFinalizedStatus: {
    backgroundColor: colors.grey[100],
    color: colors.grey[800],
  },
  noInteractionTypography: {
    color: colors.grey[500],
  },
  buttonAddCategory: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
  paperButtonAddCategory: {
    padding: theme.spacing(1),
    marginTop: theme.spacing(2),
  },
  boxButtonsConfig: {
    gap: theme.spacing(1.25),
  },
  convertIncidentButtonWrapper: {
    width: '100%',
  },
  boxButtonSkeleton: {
    display: 'flex',
    gap: '20px',
    justifyContent: 'end',
    paddingTop: '20px',
  },
}))

export default styles
